import { Event } from '~/Features/Messaging/types';

export class ApplicationEvent extends Event {
    constructor(
        public readonly currentChoicesNumber: number,
        id: string
    ) {
        super(id);
    }
}

export class AddingDifferentApplicationTypeAttempt extends Event {
    public static readonly id = 'AddingDifferentApplicationTypeAttempt';

    constructor() {
        super(AddingDifferentApplicationTypeAttempt.id);
    }
}
